/* eslint-env browser */
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js'
import { loadStripe, Stripe } from '@stripe/stripe-js'
import Axios from 'axios'
import React from 'react'

import withTranslator from '../../../client/clientjs/components/TranslatorProvider'
import { TranslatorProviderInjectedProps } from '../../../client/clientjs/components/types'
import RegisterWithPaymentPaymentForm from './RegisterWithPaymentPaymentForm'

const ValidatedInput = require('../../custom/gunki-iron-tournament-2018-pre-registration/components/ValidatedInput')

interface State {
  loading: boolean
  teamName?: string
  paymentIntent: { paymentIntentClientSecret: string; amount: number; paymentDescription: string } | undefined
  stripeInstance: Stripe | null
  stripeAccount?: string
  paymentEmail: string
  paymentName: string
  paymentCardComplete: boolean
  paymentError?: {
    type: 'validation_error'
    code: string
    message: string
  }
}

interface OwnProps {
  needTeams: boolean
  contestId: string
  stripeRedirectQueryParams?: string
}

type Props = OwnProps & TranslatorProviderInjectedProps

const MIN_TEAM_NAME_LENGTH = 3

class RegisterWithPayment extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props)
    this.state = {
      loading: false,
      teamName: undefined,
      paymentIntent: undefined,
      stripeInstance: null,
      paymentEmail: '',
      paymentName: '',
      paymentCardComplete: false,
    }
    this.openPayment = this.openPayment.bind(this)
  }

  private async openPayment() {
    this.setState({ loading: true })
    const { contestId, stripeRedirectQueryParams } = this.props
    const { teamName } = this.state
    const {
      paymentIntentClientSecret,
      amount,
      paymentDescription,
      publishableKey,
      stripeAccount,
      paymentName,
      paymentEmail,
    } = (
      await Axios.post<any>(`/api/contests/${contestId}/stripePaymentIntent`, {
        withCredentials: true,
        redirectQueryParams: stripeRedirectQueryParams,
        metadata: {
          teamName,
        },
      })
    ).data
    const stripeInstance = await (stripeAccount
      ? loadStripe(publishableKey, { stripeAccount })
      : loadStripe(publishableKey))
    this.setState({
      paymentIntent: { paymentIntentClientSecret, amount, paymentDescription },
      stripeInstance,
      stripeAccount,
      loading: false,
      paymentEmail: paymentEmail || '',
      paymentName: paymentName || '',
    })
  }

  public render() {
    const { needTeams, translate, contestId } = this.props
    const {
      loading,
      teamName,
      paymentIntent,
      stripeAccount,
      stripeInstance,
      paymentName,
      paymentEmail,
      paymentError,
    } = this.state

    if (paymentIntent && stripeInstance) {
      return (
        <Elements stripe={stripeInstance}>
          <ElementsConsumer>
            {({ stripe, elements }) =>
              elements ? (
                <RegisterWithPaymentPaymentForm
                  {...{
                    contestId,
                    elements,
                    translate,
                    stripeAccount,
                    stripeInstance,
                    paymentIntent,
                    paymentName,
                    paymentEmail,
                    paymentError,
                  }}
                />
              ) : (
                undefined
              )
            }
          </ElementsConsumer>
        </Elements>
      )
    }

    return (
      <div className="columns is-multiline is-centered has-text-centered">
        {needTeams && (
          <div className="column is-12-mobile is-8-tablet is-4-desktop">
            <ValidatedInput
              initialValue=""
              placeholder="Team Name"
              label=""
              inputId="join-team-coupon"
              autoCorrect="off"
              autoCapitalize="off"
              disabled={loading}
              valid={(value: string) => value.length > MIN_TEAM_NAME_LENGTH}
              onChange={(value: string) => this.setState({ teamName: value })}
            />
          </div>
        )}
        <div className="column is-12 has-text-centered">
          <button
            type="submit"
            className={`button is-call-to-action ${loading ? 'is-loading' : ''}`}
            disabled={loading || (needTeams && (teamName || '').length <= MIN_TEAM_NAME_LENGTH)}
            onClick={this.openPayment}
          >
            {translate(needTeams ? 'registerPayment.button.createTeam' : 'registerPayment.button.register')}
          </button>
        </div>
      </div>
    )
  }
}

export default withTranslator(RegisterWithPayment)
